import { useRef } from "react";

export default function useTempId() {
  const tempId = useRef<string | null>(null);

  if (!tempId.current) {
    const randBytes = new Uint8Array(16);
    crypto.getRandomValues(randBytes);
    tempId.current = btoa(String.fromCharCode(...randBytes)).slice(0, -2);
  }

  return tempId.current;
}
